import i18n from "../../i18n";

/**
 * The locale display dates should be written in. In Hindi that is "hi-IN"
 * (Hindi month names, Hindi relative times); in English it is whatever the
 * caller already used — `fallback`, usually the browser's — so English output
 * is exactly what it was. Read at call time, so a language switch applies on
 * the next render.
 *
 * Only for text people read: input values, ISO strings, file names and
 * placeholder autofill keep their fixed machine locales.
 */
export function uiLocale(): string | undefined;
export function uiLocale(fallback: string): string;
export function uiLocale(fallback?: string): string | undefined {
  return isHindi() ? "hi-IN" : fallback;
}

/** True while the UI is in Hindi. */
export function isHindi(): boolean {
  return (i18n.language || "").toLowerCase().startsWith("hi");
}
